/* eslint-disable jsx-a11y/anchor-is-valid */
import "./App.css";
import Header from "./components/Header";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Login from "./components/Login";
import { ClerkProvider } from "@clerk/clerk-react";
import Internal from "./components/Internal";
import External from "./components/External";
function App() {
	return (
		<div className="App">
			<ClerkProvider
				publishableKey={process.env.REACT_APP_PUBLISHABLE_KEY!}
				appearance={{
					elements: {
						footer: "hidden",
					},
				}}
			>
				<Header />
				<BrowserRouter>
					<Routes>
						<Route path="/" element={<External />} />
						<Route path="/login" element={<Login />} />
						<Route path="/internal" element={<Internal />} />
					</Routes>
				</BrowserRouter>
			</ClerkProvider>
		</div>
	);
}

export default App;
